// import {FilterMatchMode} from 'primevue/api'
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import { FilterMatchMode } from "primevue/api";
import { defineComponent } from 'vue'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import groupBy from 'lodash/groupBy';
import Tools from "@/shared/services/tools";
// import { orderBy } from "lodash";

const name = 'g-data-table'
export default defineComponent({
  name,

  components: {
    gForm,
    gButton,
  },

  props: {
    ExportarExcel:{
      type: Boolean,
      default: false, 
    },
    ExportarPdf:{
      type: Boolean,
      default: false, 
    },
    Editavel: {
      type: Boolean,
      default: false, 
    },
    colunas: {
      type: Array,
      default:() => []
    },
    valores: {
      type: Array,
      default:() => []
    },
    // listaPermitidos: {
    //   type: Array,
    //   default: []
    // },
    Imprimivel:{
      type: Boolean,
      default: false,
    },
    Calendario:{
      type: Boolean,
      default: false,
    },
    Copiavel:{
      type: Boolean,
      default: false,
    },
    Compartilhavel:{
      type: Boolean,
      default: false,
    },
    GerarOrca:{
      type: Boolean,
      default: false,
    },
    Copiaveis:{
      type: Boolean,
      default: false,
    },
    Excluivel:{
      type: Boolean,
      default: false,
    },
    Logout:{
      type: Boolean,
      default: false,
    },
    Continuavel:{
      type:Boolean,
      default:false,
    },
    Titulo:{
      type:String,
      default:"...",
    },
    maxWidthExpansivel:{
      type:String,
      default:"...",
    },
    Adicionavel: {
      type: Boolean,
      default: false,
    },
    Paginacao:{
      type: Boolean,
      default: true,
    },
    checkprancheta:{
      type: Boolean,
      default: false,
    },
    baixarOrcamento:{
      type: Boolean,
      default: false
    },
    Filtros:{ //renomear para filtros
      type: Object,
      default:()=> {
        return {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS}
        }
      }
    },
    TextoVazio:{
      type:String,
      default:"Sem dados",
    },
    NumeroLinhas:{
      type: Number,
      default:5,
    },
    TemScroll:{
      type: Boolean,
      default:true,
    },
    FiltroGeral:{
      type: Boolean,
      default: true
    },
    FiltrosEspecificos: {
      type: Boolean,
      default: true
    },
    altura:{
      type: String,
      default:"400px"
    },
    ehStatus:{
      type: Boolean,
      default: true
    },
    temColunaSelecao:{
      type: Boolean,
      default: false
    },
    dataKey:{
      type: String,
      default: "id"
    },
    bordaTopo: {
      type: Boolean,
      default: true
    },
    EscondeColunaBotao:{
      type: Boolean,
      default: false
    },
    DownloadPDF: {
      type: Boolean,
      default: false,
    },
    temColunaSelecaoUnica: {
      type: Boolean,
      default: false,
    },
    ButtonStatus: {
      type: Boolean,
      default: false,
    },    
    colunaColorida:{
      type: String,
      default: ''
    },
    OrcamentoQuantidade:{
      type: Boolean,
      default: false,
    },
    colunaCores: {
      type: String,
      default: 'corStatus'
    },
    GetStatusColors:{
      type: String,
      default: '',
    },
    GetVencimentoColors:{
      type: String,
      default: '',
    },
    Historico:{
      type: Boolean,
      default: false
    },
    maisOpcoes:{
      type: Boolean,
      default: false
    },
    Carregamento:{
      type: Boolean,
      default: false
    },
    Reorcavel:{
      type: Array,
      default:() => []
    },
    NotaFiscal:{
      type: Boolean,
      default: false
    },
    campoAgrupador: {
      type: String,
      default: null,
    },
    campoExibicaoGrupo: {
      type: String,
      default: null,
    },
    campoFooterTotal: {
      type: String,
      default: null
    },
    ehExpansivel:{
      type:Boolean,
      default:false
    },
    esconderColunaFrozen:{
      type:Boolean,
      default:false
    },
    esconderHeader:{
      type:Boolean,
      default:false
    },
    Financeiro:{
      type: Boolean,
      default: false
    },
    Expansivel: {
      type: Boolean,
      default: false
    },
    campoOrdenador: {
      type: String,
      default: null
    },
    Detalhes: {
      type: Boolean,
      default: false
    },
    ComponentesExpandidos: {
      type: Boolean,
      default: false
    },
    Parcelas: {
      type: Boolean,
      default: false
    },
    Pedidos: {
      type: Boolean,
      default: false
    },
    TextoPrancheta: {
      type: String,
      default: "Prancheta"
    },
    TextEditar: {
      type: String,
      default: "Editar"
    },
    TextCopiar: {
      type: String,
      default: "Copiar"
    },
    TextImprimir: {
      type: String,
      default: "Imprimir"
    },
    TextCompartilhar: {
      type: String,
      default: "Compartilhar"
    },
    TextDownload: {
      type: String,
      default: "Download"
    },
    TextLogout: {
      type: String,
      default: "Logout"
    },
    TextExcluir: {
      type: String,
      default: "Excluir"
    },
    TextDetalhes: {
      type: String,
      default: "Detalhes"
    },
    TextCalendario: {
      type: String,
      default: "Calendário"
    },
    TextComponentes: {
      type: String,
      default: "Expandir Componentes"
    },
    TextHistorico: {
      type: String,
      default: "Histórico"
    },
    TextPedidos: {
      type: String,
      default: "Pedidos"
    },
    TextNotaFiscal: {
      type: String,
      default: "Nota Fiscal"
    },
    TextParcelas: {
      type: String,
      default: "Parcelas"
    },
    TextFinanceiro: {
      type: String,
      default: "Financeiro"
    },
    TextCarregamento: {
      type: String,
      default: "Instruções de Carregamento"
    },
    TextReorcamento: {
      type: String,
      default: "Reorçamento"
    },
    TextoBaixaCarta: {
      type: String,
      default: "Dar Baixa na Carta"
    },
    TextContinuar: {
      type: String,
      default: "Continuar"
    },
    BaixarCartaPropostaBotao:{
      type: Boolean,
      default: false,
    },
    numeroBotoesAcao: {
      type: Number,
      default: 2
    },
    atribuiIdAutomatico:{
      type: Boolean,
      default: false,
    },
    ehSemDados:{
      type: Boolean,
      default :true
    },
    ehReordenavel:{
      type: Boolean,
      default :true
    },
    temFooter: {
      type: Boolean,
      default: false
    },
    telaComissao: {
      type: Boolean,
      default: false
    },
    telaNotasFiscais: {
      type: Boolean,
      default: false
    },
    telaTitulos: {
      type: Boolean,
      default: false
    },
    telaProdutosEstoque: {
      type: Boolean,
      default: false
    },
    telaExpedidosFaturados: {
      type: Boolean,
      default: false
    },
    linhasExpandidas: {
      type: Array,
      default: () => []
    },
    bordaDatatable: {
      type: Boolean,
      default: true
    },
  },

  mounted () {
    this.semDados();
    if(this.valores[0] && this.atribuiIdAutomatico) {
      if(this.valores[0].id === undefined || this.valores[0].Id === undefined){
        this.valores.forEach((e, i) => e.id = i)
      }
    }
  },

  updated () {
    this.semDados();
  },

  data () {
    return {
      carregando: false,
      time: 0,
      count:0,
      dropdownVisible: false,
      editingRows:[],
      esconderColunas:false,
      Filtrable:false,
      key:0,
      linhaArray:[],
      linhasExpandidasInternas: [],
      linhasExpansiveis: [],
      linhasSelecionadas: [],
      ProdutosClienteArray: [],
      listaPermitidos: [],
      ReordenableColumns: true,
      idNotasFiscais: null
    }
  },

  methods: {
    openDropdown() {
      // eslint-disable-next-line no-debugger
      this.dropdownVisible = true;
    },
    closeDropdown() {
      this.dropdownVisible = false;
    },

    formataValorMonetarioDataTable(valor){
      if(valor){
        return Tools.valorMonetario4Digitos(valor)
      }
      return "R$ 0,0"
    }, 

    formataValorNumberDataTable(valor){
      if(valor){
        return Tools.valorDecimalFormatado(valor)
      }
      return "0"
    }, 

    retornaDataHoraPdf(){
      const hoje =  new Date
      return `${hoje.getDate().toString().padStart(2, '0')}/${(hoje.getMonth()+1).toString().padStart(2, '0')}/${hoje.getFullYear()} ${hoje.getHours().toString().padStart(2, '0')}:${hoje.getMinutes().toString().padStart(2, '0')}`
    },

    exportPdf(){
      const doc = new jsPDF()
      const valoresAgrupados =  groupBy(this.valores,"empresaCliente")

      const data = this.retornaDataHoraPdf() 
      doc.setFontSize(12)
      doc.text(data,4,8)
      
      const columnIndexToFormatMoney=[2,3,4,5]
      
      for(var chave in valoresAgrupados){
      let columns =  this.colunas.map((m)=>{
        return {
          header:m.header,
          dataKey:m.field,
        }
      })

      let headercolumns =  this.colunas.map(m=>{
        return {
          content:m.header,
          colspan:1,
        }
      })

      let  columnStyles = {}
      // headercolumns.forEach((e,index)=>{
      //   if(columnIndexToFormatMoney.includes(index)){
      //   }
        
      // })
      /*eslint-disable*/
             
      autoTable(doc, {
        head:[[{content:chave.trim(),colSpan:headercolumns.length,data,styles:{fillColor:"#59311f",textColor:"white"}}] ,headercolumns],
        columns:columns,
        columnStyles: columnStyles,
        body: valoresAgrupados[chave],
        headStyles:{fillColor:"#fcba2d",textColor:"#59311f"},
        margin:{right: 4 ,left: 4 ,top: 14 ,bottom: 4 },
        rowPageBreak: 'avoid',

        willDrawCell: (data) => {
          if (data.section === 'body' && columnIndexToFormatMoney.includes(data.column.index) && data.cell.text.length > 0) {
            data.cell.text=[this.formataValorNumberDataTable(parseFloat(data.cell.text.at(0)))]
          }
        }
      })
    }
      doc.save('file.pdf')
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    // getPermissaoReOrcamentos(){

    //   this.$isLoading(true)
    //   OrcamentoController.getPermissaoReOrcamentos().requisicao
    //   .then(res => {
   
    //     this.listaPermitidos = res.data.data
    //     this.$isLoading(false);
    //   })
    // },
    retornaSubLinhas(slotProps){
      this.slotProps = slotProps
    },
    ehColunaStatus(nomeColuna){
      if(nomeColuna === 'orcamentoSincronismoEnum' ||nomeColuna === 'dataVencimentoFormatada' || this.colunaColorida.includes(nomeColuna) ){
        return true
      }
      return false
    },
    retornaSoma(campoAgrupador){
            
    if(this.telaComissao == true){
      const arrayValoresSoma = this.valores.filter(x=>{
        
        if(campoAgrupador === x.empresaCliente){
          return {
            valorTitulo:x.valorTitulo,
            comissao:x.comissao,
          }
        }
        
      })

      let somaValorTitulo = 0
      let somaComissao = 0

      if(arrayValoresSoma.length > 0){
        arrayValoresSoma.forEach(x => {
          somaValorTitulo = somaValorTitulo + x.valorTitulo
        })
        
        arrayValoresSoma.forEach(x => {
          somaComissao = somaComissao + x.comissao
        })        
        
        
      }
      return {
        valorTitulo:somaValorTitulo.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
        comissao:somaComissao.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
      }
      
    }
    if(this.telaNotasFiscais == true){
      const arrayValoresSoma = this.valores.filter(x=>{
        
        if(campoAgrupador === x.empresaCliente){
          return {
            valorTotalNotaFiscalFatura:x.valorTotalNotaFiscalFatura
          }
        }
        
      })

      let somaValorNotaFiscalFatura = 0

      if(arrayValoresSoma.length > 0){
        arrayValoresSoma.forEach(x => {
          somaValorNotaFiscalFatura = somaValorNotaFiscalFatura + x.valorTotalNotaFiscalFatura
        })
                
      }
      return {
        valorSomaNotaFiscal:somaValorNotaFiscalFatura.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
      }
    }
    if(this.telaTitulos == true){
      const arrayValoresSoma = this.valores.filter(x=>{
        
        if(campoAgrupador === x.labelAgrupador){
          return {
            valorBruto:x.valorBruto
          }
        }
        
      })

      let somaValorBruto = 0

      if(arrayValoresSoma.length > 0){
        arrayValoresSoma.forEach(x => {
          somaValorBruto = somaValorBruto + x.valorBruto
        })
                
      }
      return {
        somaFinalValorBruto:somaValorBruto.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
      }
    }
    if(this.telaProdutosEstoque == true){
      const arrayValoresSoma = this.valores.filter(x=>{
        
        if(campoAgrupador === x.empresaCliente){
          return {
            quantidadeCaixas:x.quantidadeCaixas,
            quantidadeFolhas:x.quantidadeFolhas,
            valorTotal: x.valorTotal
          }
        }
        
      })

      let somaCaixas = 0
      let somaFolhas = 0
      let somaValorTotal = 0

      if(arrayValoresSoma.length > 0){
        arrayValoresSoma.forEach(x => {
          somaCaixas = somaCaixas + x.quantidadeCaixas
        })
        
        arrayValoresSoma.forEach(x => {
          somaFolhas = somaFolhas + x.quantidadeFolhas
        })        

        arrayValoresSoma.forEach(x => {
          somaValorTotal = somaValorTotal + x.valorTotal
        })   
        
        
      }
      return {
        valorFinalSomaCaixas:somaCaixas,
        valorFinalSomaFolhas:somaFolhas,
        valorFinalSomaValorTotal:somaValorTotal.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}),
      }
      
    }
    if(this.telaExpedidosFaturados == true){
      const arrayValoresSoma = this.valores.filter(x=>{
        
        if(campoAgrupador === x.empresaCliente){
          return {
            quantidadeExpedida:x.quantidadeExpedida,
          }
        }
        
      })

      let somaQuantidadeExpedida = 0

      if(arrayValoresSoma.length > 0){
        arrayValoresSoma.forEach(x => {
          somaQuantidadeExpedida = somaQuantidadeExpedida + x.quantidadeExpedida
        })        
      }
      return {
        valorFinalSomaQuantidadeExpedida:somaQuantidadeExpedida,
      }
      
    }
    },
    VerificarNotaFiscalLista(id) {
      this.idNotasFiscais = id
      // let verificar = this.NotaFiscal.find((Element) => Element === id)
      // if(verificar === null || verificar === undefined) return false
      // return true

    },
    VerificarReorcavel(id) {
      let verificar = this.Reorcavel.find((Element) => Element === id)
      if(verificar === null || verificar === undefined) return false
      return true

    },
    retornaLinhasSelecionadas(){
      return this.linhasSelecionadas
    },
    // ehColunaChekBox(nomeColuna){

    //   return nomeColuna === "vin" ? true : false
    //   // return typeof value === "boolean" ? true : false
    // },
    CopiaveisClick(data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('CopiaveisClick', dataNaoReativa)
    },
    GerarOrcaClick(data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('clickGerarOrca', dataNaoReativa)
    },
    montaEstilo(StatusEnumTexto){
      if(!this.listaDeStatus.includes(StatusEnumTexto)){
        return null
      }
      return this.estilosStatus[status]
    },
    getColorStatus (data, field) {
      if(field === 'dataVencimentoFormatada' && data.corStatus2) return data[this.GetVencimentoColors]
      if (this.GetStatusColors === '') return data.colorStatus
      return data[this.GetStatusColors]
    },
    getColorSVencimento (data) {
      if (this.GetVencimentoColors === '') return data.colorStatus
      return data[this.GetVencimentoColors]
    },

    semDados() { },

    forceUpdate(){ //forçar a recarga do datagrid
      this.key++;

      let count = 0
      var interval = setInterval(() => {
        count++
        this.carregando=true
        if(count > 5){
            clearInterval(interval);
            this.carregando=false
            return;
          }
    }, 200);
    },

    onRowClick(event){
      let dataJson = JSON.stringify(event.data)
      let dataNaoReativa = JSON.parse(dataJson)
      if(this.time === 0){
        this.time = new Date().getTime();
        this.$emit('clickLinha', dataNaoReativa)
      }
      else{
        if((new Date().getTime() - this.time) < 800){
          this.$emit('duploClickLinha', dataNaoReativa)
        }
        else{
          this.time = new Date().getTime();
          this.$emit('clickLinha', dataNaoReativa);

        }
      }
    },

    // onDlbRowClick(event){
    //   /*eslint-disable*/
    //   let dataJson = JSON.stringify(event.data)
    //   let dataNaoReativa = JSON.parse(dataJson)
    //   this.$emit('duploClickLinha', dataNaoReativa)
    // },

    onRowEditSave(event) {
      let { newData, index } = event;
      this.DataTableInfo[index] = newData;
    },
    onRowEditInit(event) { // para obter os dados passando pelo evento de edição do componente do primevue
      let dataJson = JSON.stringify(event.data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('teste', dataNaoReativa)

    },
    imprimir(data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)

      this.$emit('clickImprimir', dataNaoReativa)
    },
    downloadPDF(data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)

      this.$emit('downloadPDF', dataNaoReativa)
    },
    editar(data, index) { // para obter os dados sem passar pelo evento de edição do componente do primevue
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)

      this.$emit('editar', dataNaoReativa, index)
      this.enviarLinha(data)
    },

    enviarLinha(data)
    {

      let index = this.valores.findIndex((Element) => JSON.stringify(Element) == JSON.stringify(data))

      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)

      this.$emit('getlinha', dataNaoReativa, index)
    },

    onCompartilhavel(data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)

      this.$emit('onCompartilhavel', dataNaoReativa)
    },

    calendario(data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('calendario', dataNaoReativa)
    },

    // excluir(data) {
    //   let index = this.valores.findIndex((Element) => JSON.stringify(Element) == JSON.stringify(data))

    //   // para obter os dados sem passar pelo evento de edição do componente do primevue
    //   let dataJson = JSON.stringify(data)
    //   let dataNaoReativa = JSON.parse(dataJson)
    //   // Object.keys(dataNaoReativa).forEach(prop => {

    //   //   dataNaoReativa[prop] = null

    //   // })

    //   this.$emit('excluir', dataNaoReativa, index)
    // },
    onPedidos(data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('onPedidos', dataNaoReativa)
    },
    Reorcavels (data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('abrePopup', dataNaoReativa)
    },

    OrcaQuantidade (data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('abreQuantidade', dataNaoReativa)
    },
    logout(data, index) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('logout', dataNaoReativa, index)
    },
    excluir(data, index) {
      //excluir // para obter os dados sem passar pelo evento de edição do componente do primevue
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('excluir', dataNaoReativa, index)
    },
    isFiltrable(){

      this.Filtrable = !this.Filtrable
    },
    isReordenableColumns(){
      this.ReordenableColumns = !this.ReordenableColumns
    },
    onCopiavel(data){
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)
      this.$emit('clickCopiar', dataNaoReativa);
    },

    onImprimivel(){

    },
    adicionar(){
      this.$emit('acaoAdicionar')

    },
    onNotaFiscal(data) {
      let dataJson = JSON.stringify(data)
      let dataNaoReativa = JSON.parse(dataJson)

      this.$emit('onNotaFiscal', dataNaoReativa)
    }
  },


  computed: {
    mostraColunas(){
      return (!this.valores || this.valores.length === 0)
    },
    sizeAcoes(){
      return `${(this.numeroBotoesAcao) * 45}px`
    },
    justify(){
      if(this.numeroBotoesAcao === 1 || this.numeroBotoesAcao === 2)
        return 'start'
      return 'end'
    }
  },

  watch: {
    linhasExpandidas() {
      this.linhasExpandidasInternas = this.linhasExpandidas
    }
  }
});